/**
 * ROI is shown to libra-executive users. Gecko internals are not included in
 * that permission; they only see it after opting in on this dashboard
 * (`visibleUserIds`).
 */
export function canViewExecutiveRoi({
  hasLibraExecutiveAccess,
  isGeckoInternal,
  userId,
  visibleUserIds,
}: {
  hasLibraExecutiveAccess: boolean
  isGeckoInternal: boolean
  userId: string | undefined
  visibleUserIds: ReadonlyArray<string> | undefined
}): boolean {
  if (hasLibraExecutiveAccess) return true
  if (!isGeckoInternal) return false
  return userId !== undefined && (visibleUserIds?.includes(userId) ?? false)
}

export function nextRoiVisibleUserIds(
  visibleUserIds: ReadonlyArray<string> | undefined,
  userId: string,
  show: boolean
): string[] {
  const current = visibleUserIds ?? []
  if (show) {
    return current.includes(userId) ? [...current] : [...current, userId]
  }
  return current.filter((id) => id !== userId)
}
